import apiClient from '@/utils/api-client'
import AuthService from '@/services/auth-service'

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;
let refreshPromise: Promise<boolean> | null = null;
const setup = () => {
    apiClient.interceptors.request.use(
        (config) => {
            if (config.headers === undefined) {
                config.headers = {};
            }
            const token = localStorage.getItem('access_token')
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    apiClient.interceptors.response.use(
        (res) =>  {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;

            if (err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    if (!refreshPromise) {
                        refreshPromise = AuthService.refreshToken()
                            .then((response) => {
                                refreshPromise = null;
                                return response;
                            })
                            .catch((error) => {
                                refreshPromise = null;
                                throw error;
                            });
                    }
                    try {
                        const response = await refreshPromise;
                        return apiClient(originalConfig); // retry the original request
                    } catch (e) {
                        return Promise.reject(e);
                    }
                }
            }

            // Initialize retry count
            originalConfig._retryCount = originalConfig._retryCount || 1;

            // Retry logic for other failures (network/server errors, etc.)
            const shouldRetry = (!err.response || err.response.status >= 500) && originalConfig._retryCount < MAX_RETRIES;

            if (shouldRetry) {
                originalConfig._retryCount += 1;
                await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
                return apiClient(originalConfig); // retry original request
            }

            return Promise.reject(err); // out of retries
        }
    );
};

export default setup;